import React from 'react';
import './index.scss';

const Switch = props => {
  let { onSwitchStateChanged, enabled = true, checked } = props;

  return (
    <div
      onClick={() => enabled && onSwitchStateChanged(!checked)}
      className={`pointer ${checked ? 'switch-container-on' : 'switch-container-off'}`}
    >
      <div className={`rounded-circle switcher ${checked ? 'on' : 'off'}`}></div>
    </div>
  );
};

export default Switch;
